<template>
  <div>
    <tabs :tabs="tabs"></tabs>
  </div>
</template>

<script>
import Tabs from "./Components/Tabs";
import SriSmi from "./srismi";
import ACT from "./ACT";
import SAT from "./SAT";
import SBAC from "./SBAC";
import PhysicalPerformanceMeasures from "./PhysicalPerformanceMeasures";
import IELTS from "./IELTS";
import TOEFL from "./TOEFL";

export default {
  components: { Tabs },
  data() {
    //[Warning] Changing the tab order will affect the router link of the student assessments
    const tabs = [
      {
        name: "srismi",
        label: "SRI&SMI",
        component: SriSmi
      },
      {
        name: "act",
        label: "ACT",
        component: ACT
      },
      {
        name: "sbac",
        label: "SBAC",
        component: SBAC
      },
      {
        name: "Physical Performance Measures",
        label: "Physical Performance Measures",
        component: PhysicalPerformanceMeasures
      },
      {
        name: "IELTS",
        label: "IELTS",
        component: IELTS
      },
      {
        name: "TOEFL",
        label: "TOEFL",
        component: TOEFL
      },
      {
        name: "sat",
        label: "SAT",
        component: SAT
      }
    ];
    return {
      tabs
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
